import cx from 'clsx';
import React, { FunctionComponent } from 'react';
import { LinkWrapper } from '..';
import styles from './Link.module.scss';
import typographyStyles from 'styles/global/typography.module.scss';
import { ArrowSmallRight as ArrowSmallRightIcon } from 'assets/icons';
import Icon from '../Icon/Icon';

interface OwnProps {
  size?: 'regular' | 'small';
  color?: 'accent';
}

type LinkProps = JSX.IntrinsicElements['a'] & OwnProps;

const Link: FunctionComponent<LinkProps> = props => {
  const { color = 'accent', className, children, size = 'regular', ...rest } = props;

  const linkClassName = cx({
    [typographyStyles.new_neue_16]: size === 'regular',
    [styles.link]: true,
    [styles[size]]: true,
    [styles[color]]: true,
    ...(className && { [className]: true }),
  });

  return (
    <LinkWrapper className={linkClassName} {...rest}>
      {children}
      {children && <Icon icon={ArrowSmallRightIcon} size={11} />}
    </LinkWrapper>
  );
};

export default Link;
